import appsettings from "@/store/app-settings";
import { axiosGet, axiosPost } from "@/store/api/axiosUtils.js";
import * as userData from "@/auth/localStorageUtils.js";

const search = (params) => {
  return axiosGet(appsettings.ocpbComplaintAPIUrl + "api/Department/Search", params);
};

const searchDepartmentInternal = (params) => {
  return axiosGet(appsettings.ocpbComplaintAPIUrl + "api/Department/SearchDepartmentInternal", params);
};

const getById = (id) => {
  const params = {
    id,
  };

  return axiosGet(appsettings.ocpbComplaintAPIUrl + "api/Department/GetById", params);
};

const updateItem = (params) => {
  return axiosPost(
    appsettings.ocpbComplaintAPIUrl +
      "api/Department/Update?userId=" +
      userData.userId(),
    params
  );
};

const updateItemActive = (id, isActive) => {
  const params = {
    id,
    isActive,
    userId: userData.userId(),
  };

  return axiosPost(
    appsettings.ocpbComplaintAPIUrl + "api/Department/UpdateActive",
    params
  );
};

const deleteItem = (id) => {
  return axiosPost(
    appsettings.ocpbComplaintAPIUrl +
      "api/Department/Delete?id=" +
      id +
      "&userId=" +
      userData.userId()
  );
};

const searchdepartmentinternal =(params)=>{
  return axiosGet(appsettings.ocpbComplaintAPIUrl + "api/Department/SearchDepartmentInternal", params);
};

export {
  search,
  searchDepartmentInternal,
  getById,
  updateItem,
  updateItemActive,
  deleteItem,
  searchdepartmentinternal,
};
